import * as _ from "lodash";

export namespace DictionaryAudioParser {
  export function parseAudioUrl(sound: any): string | null {
    let filename = null;
    if (_.isArray(sound)) {
      const urls = sound
        .map(aSound => _parseAudioFilenameWav(aSound))
        .filter(url => !!url);
      if (urls.length > 0) {
        filename = urls[0];
      }
    } else {
      filename = _parseAudioFilenameWav(sound);
    }

    if (!filename) {
      return null;
    }

    // need to prefix with base URL + directory that is 1st letter of the filename:
    // "https://media.merriam-webster.com/soundc11/h/heart001.wav"
    //
    // there are some exceptions. ref: https://www.dictionaryapi.com/info/faq-audio-image.htm#collegiate
    //
    // If the file name begins with "bix", the subdirectory should be "bix".
    // If the file name begins with "gg", the subdirectory should be "gg".
    // If the file name begins with a number, the subdirectory should be "number"

    const baseUrl = "https://media.merriam-webster.com/soundc11/";

    let dirName = filename[0];

    if (filename.startsWith("bix")) {
      dirName = "bix";
    }
    if (filename.startsWith("gg")) {
      dirName = "gg";
    }
    if (isFinite(Number(filename[0]))) {
      dirName = "number";
    }

    return `${baseUrl}${dirName}/${filename}`;
  }

  function _parseAudioFilenameWav(sound: any): string | null {
    if (!sound) {
      return null;
    }

    if (typeof sound === "string" && (sound as string).endsWith(".wav")) {
      return sound;
    }

    const filename = sound.wav;

    if (_.isArray(sound.wav)) {
      return sound.wav[0];
    }

    return filename;
  }
}



// WEBPACK FOOTER //
// ./services/dictionary/DictionaryAudioParser.ts